import { Link } from "react-router-dom";
import { Figure } from "../Figure";
import { ROUTES } from "../../lib/routes";
import { MAIN_BLOCK } from "../../lib/campusMedia";

/**
 * The closing call to apply, laid over the institution itself — the main
 * academic block across the front lawn, the building a visitor arrives at.
 *
 * The photograph is the section's background, masked so it fades out across
 * the copy: the band keeps its gold ground (and its navy type keeps its
 * contrast) on the reading side, and resolves into the building on the other.
 * Masking rather than tinting keeps it correct under all seven palettes,
 * since no gold value is hard-coded into the gradient.
 *
 * Copy checked against /admissions rather than kept as written: the programme
 * list was missing MCA, and two claims described a process the institute does
 * not run. There is no document upload — step four is reporting to the
 * admissions office with originals — and no visit-booking facility; what
 * exists is an enquiry desk and a recorded campus tour.
 */
export function CtaStrip() {
  return (
    <section className="gold-strip">
      {/* Decorative: the building is named in the copy, so it is hidden from
          assistive tech rather than announced twice. */}
      <div className="gold-strip-bg" aria-hidden="true">
        <Figure
          media={MAIN_BLOCK}
          fallbackLabel="BIET · MAIN ACADEMIC BLOCK"
          aspect="auto"
          sizes="100vw"
          style={{ position: "absolute", inset: 0 }}
        />
      </div>
      <div className="container gold-strip-inner">
        <div className="reveal">
          <div className="kicker">AY 2026 — 27 · APPLICATIONS OPEN</div>
          <h2>Apply to a college that has graduated engineers since 1979.</h2>
          <p>
            B.E., M.Tech, MBA, MCA and Ph.D. applications are open. Check the eligibility for
            your programme, read the notified fees, and send the admissions office an enquiry.
          </p>
          <div className="cta-strip-actions">
            <Link
              className="btn btn-dark"
              to={ROUTES.admissions}
              style={{
                background: "var(--navy-900)",
                color: "#fff",
                borderColor: "var(--navy-900)",
              }}
            >
              Apply to BIET <span>→</span>
            </Link>
            <Link className="btn-link" to={`${ROUTES.contact}#enquiry`}>
              Send an enquiry <span className="arr">→</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
